import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import CMSComponents, { CMSThemeProvider, cmsComponents, CMSRenderer } from '@sainsburys-tech/cms-components'
import * as Styled from './CustomerGeneratedContentWrapper.styles'
import { useFeatureFlagContext } from '@/javascript/providers/FeatureFlagContext/FeatureFlagContext'

const CustomerGeneratedContentWrapper = ({ brand = 'ARGOS', className = '', productId = '', isFullWidth }) => {
  const getBrandSpecificBodyCopy = () => {
    switch (brand?.toUpperCase()) {
      case 'ARGOS':
      default:
        return 'Styled by you, loved by us. Click on the photos below to shop the look. For the chance to feature in our galleries, tag your photos with @HabitatUK, @Argos, or @Tuclothing on Instagram.'
      case 'HABITAT':
        return 'Styled by you, loved by us. Click on the photos below to shop the look. For the chance to feature in our galleries, tag your photos with @HabitatUK on Instagram.'
      case 'TU':
        return 'Styled by you, loved by us. Click on the photos below to shop the look. For the chance to feature in our galleries, tag your photos with @Tuclothing on Instagram.'
    }
  }

  const templateProps = {
    type: 'C002',
    productIdentifier: productId,
    heading: 'Customer gallery',
    bodyCopy: getBrandSpecificBodyCopy(),
    layout: 'slider'
  }

  const { PDP_V2_FLAG } = useFeatureFlagContext()

  useEffect(() => {
    if (!PDP_V2_FLAG) return

    const observer = new MutationObserver(() => {
      const c002Container = document.querySelector('[data-testid="c002-container"]')
      if (c002Container) {
        c002Container.classList?.add('cgc-box')
        observer.disconnect()
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })

    // eslint-disable-next-line consistent-return
    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <CMSThemeProvider brand={brand.toLowerCase()}>
      <Styled.Section isFullWidth={isFullWidth} className={className} data-test='pdp-social-media-content-cgc-wrapper'>
        <CMSComponents components={cmsComponents}>
          <CMSRenderer {...templateProps} />
        </CMSComponents>
      </Styled.Section>
    </CMSThemeProvider>
  )
}

CustomerGeneratedContentWrapper.propTypes = {
  className: PropTypes.string,
  isFullWidth: PropTypes.bool,
  productId: PropTypes.string,
  brand: PropTypes.string
}

CustomerGeneratedContentWrapper.defaultProps = {
  className: '',
  isFullWidth: false,
  productId: '',
  brand: 'ARGOS'
}

export default CustomerGeneratedContentWrapper
